// src/utils/integrationTracking.ts
const KEY = "integration_source";
const TS_KEY = `${KEY}_ts`;
const TTL_MS = 30 * 60 * 1000; // 30 min

const hasWindow = () => typeof window !== "undefined";
const ss = () => (hasWindow() ? window.sessionStorage : null);

export function setIntegrationSource(src: string) {
  const s = ss();
  if (!s || !src) return;
  s.setItem(KEY, src.trim().toLowerCase());
  s.setItem(TS_KEY, String(Date.now()));
}

export function getIntegrationSource(): string | null {
  const s = ss();
  if (!s) return null;
  const val = s.getItem(KEY);
  const ts = Number(s.getItem(TS_KEY) || 0);
  if (!val || !ts) return null;
  return Date.now() - ts <= TTL_MS ? val : null;
}

export function buildUrlWithParams(baseUrl: string, params: Record<string, string | undefined>) {
  try {
    const u = new URL(baseUrl, hasWindow() ? window.location.origin : "https://example.com");
    Object.entries(params).forEach(([k, v]) => {
      if (v != null && v !== "") u.searchParams.set(k, v);
    });
    return u.toString();
  } catch {
    const hasQuery = baseUrl.includes("?");
    const qp = Object.entries(params)
      .filter(([, v]) => v != null && v !== "")
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
      .join("&");
    return baseUrl + (hasQuery ? "&" : "?") + qp;
  }
}

export function buildCalUrl(baseCalUrl: string) {
  const src = getIntegrationSource();
  if (!src) return baseCalUrl;
  return buildUrlWithParams(baseCalUrl, {
    utm_source: "integracoes-poderosas",
    utm_medium: "site",
    utm_campaign: "marcacao-reuniao",
    utm_content: src,
    integration_source: src, // extra opcional
  });
}
